import logo from "./OIG4.jpg";
import heroBg from "./Image3.png";
import World1 from "./World1.webp";
import World2 from "./World2.webp";
import World3 from "./World3.webp";
import World4 from "./World4.webp";
import { Link, useLocation } from "react-router-dom";
import { FaCogs, FaUsers, FaGlobe } from "react-icons/fa";

function Home() {
  return (
    <>
      {/* Hero Section */}
      <div
        className="h-[80vh] flex flex-col items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${heroBg})`,
        }}
      >
        <img
          src={logo}
          className="w-32 h-32 rounded-full mb-4"
          alt="Omnicraft Studios Logo"
        />
        <h1 className="text-4xl font-bold text-white mb-2">
          Welcome to Omnicraft SMP
        </h1>
        <p className="text-xl text-white mb-4">Your Adventure Awaits!</p>
        <Link
          to="/application"
          className="bg-blue-600 text-white px-6 py-3 rounded-full text-lg hover:bg-blue-700 link"
        >
          Join Now
        </Link>
      </div>
      {/* <iframe
        src="https://discord.com/widget?id=1218413388028186705&theme=dark"
        width="350"
        height="500"
        allowtransparency="true"
        frameborder="0"
        sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
      ></iframe> */}
      {/* Features Section */}
      <div className="py-12 bg-zinc-900">
        <div className="mx-4">
          <h2 className="text-3xl font-bold text-white text-center mb-8">
            Why Join Omnicraft SMP?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mx-auto max-w-5xl">
            <div className="bg-zinc-800 p-6 rounded-lg shadow-md text-white">
              <FaCogs className="text-4xl mb-4 mx-auto" />
              <h3 className="text-xl font-semibold mb-2">Custom Modpack</h3>
              <p>
                Enhance your gameplay with unique mods designed for fun and
                creativity.
              </p>
            </div>
            <div className="bg-zinc-800 p-6 rounded-lg shadow-md text-white">
              <FaUsers className="text-4xl mb-4 mx-auto" />
              <h3 className="text-xl font-semibold mb-2">Active Community</h3>
              <p>
                Join a friendly player base, participate in events, and make new
                friends.
              </p>
            </div>
            <div className="bg-zinc-800 p-6 rounded-lg shadow-md text-white">
              <FaGlobe className="text-4xl mb-4 mx-auto" />
              <h3 className="text-xl font-semibold mb-2">Expansive World</h3>
              <p>
                Explore a vast world, build your dream base, and discover
                treasures.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <div className="py-12 bg-zinc-800 ">
        <div className="mx-4">
          <h2 className="text-3xl font-bold text-white text-center mb-8">
            What Our Players Say
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mx-auto max-w-5xl">
            <div className="bg-zinc-700 p-6 rounded-lg text-white">
              <p className="italic">
                "The community is very welcoming and friendly which makes
                OmniCraft SMP a very fun server."
              </p>
              <p className="mt-4 font-semibold">- j04g</p>
            </div>
            <div className="bg-zinc-700 p-6 rounded-lg text-white">
              <p className="italic">
                "Omnicraft is a modded Minecraft server with ever-changing
                seasonal themes, new mods, and fresh adventures each cycle. Join
                the fun, explore, build, and thrive in a world that’s always
                evolving!"
              </p>
              <p className="mt-4 font-semibold">- VoidedMC85</p>
            </div>
            <div className="bg-zinc-700 p-6 rounded-lg text-white">
              <p className="italic">
                "OmniCraft is the server where you can just chill with friends."
              </p>
              <p className="mt-4 font-semibold">- BlockBard</p>
            </div>
          </div>
        </div>
      </div>

      {/* Gallery Section */}
      <div className="py-12 bg-zinc-900">
        <div className="mx-4">
          <h2 className="text-3xl font-bold text-white text-center mb-8">
            Explore Our World
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mx-auto max-w-5xl">
            <img
              src={World1}
              className="w-full h-48 object-cover rounded-lg"
              alt="Gallery 1"
            />
            <img
              src={World2}
              className="w-full h-48 object-cover rounded-lg"
              alt="Gallery 2"
            />
            <img
              src={World3}
              className="w-full h-48 object-cover rounded-lg"
              alt="Gallery 3"
            />
            <img
              src={World4}
              className="w-full h-48 object-cover rounded-lg"
              alt="Gallery 4"
            />
          </div>
        </div>
      </div>

      {/* About Section */}
      <div className="py-12 bg-zinc-800">
        <div className="mx-4">
          <h2 className="text-3xl font-bold text-white text-center mb-8">
            About Omnicraft Studios
          </h2>
          <p className="text-lg text-white text-center max-w-3xl mx-auto">
            At Omnicraft Studios, we create a welcoming environment built on
            creativity, collaboration, and respect. Whether you’re a veteran or
            new to Minecraft, join our growing community and find your home!
          </p>
        </div>
      </div>

      {/* News Section */}
      {/* <div className="py-12 bg-zinc-800">
        <div className="mx-4">
          <h2 className="text-3xl font-bold text-white text-center mb-8">
            Previous Server News
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mx-auto max-w-5xl">
            <div></div>
            <div className="bg-zinc-700 p-6 rounded-lg shadow-md text-white">
              <h3 className="text-xl font-semibold mb-2">
                Season 4 Launch: New Mods and Features!
              </h3>
              <p className="mb-4">
                We're excited to announce the launch of Season 4 with a brand
                new modpack and exciting features. Join us for the grand opening
                event this weekend, June 1st!
              </p>
              <small className="text-zinc-400">May 25, 2025</small>
              <Link
                to="/news/season4launch"
                className="block mt-2 text-blue-500 hover:underline"
              >
                Read More
              </Link>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default Home;
